import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import _ from 'lodash'

import { Row, Col } from 'antd'

class DashboardRemainingBox extends Component {
  render () {
    const { t, match: { params }, projects } = this.props
    const currentProject = projects[params.projectId]

    const { numbers } = this.props

    const remainingContactsSum = _.sum(_.values(numbers))

    const columnStyle = {
      fontWeight: 'bold',
      height: 50,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }

    return (
      <div style={{ marginTop: 30, padding: '10px 15px', border: '1px solid #e8e8e8' }}>

        <div
          style={{
            fontWeight: 'bold',
            height: 20,
            position: 'relative',
            top: -20,
            marginBottom: -20,
            padding: '0 5px',
            background: '#fff'
          }}
        >
          Remaining
        </div>

        <Row type='flex' justify='space-around' style={{ textAlign: 'center' }}>

          <Col>
            <span style={{ fontSize: 40 }}>{remainingContactsSum}</span>
          </Col>

          <Col>
            <div style={{ ...columnStyle }}>Not contacted</div>
            <span>{numbers[0]}</span>
          </Col>

          {_.times(currentProject.possibleCalls, num => (
            <Col key={num}>
              <div style={{ ...columnStyle }}>{t(`contact.status.call${num + 1}`)}</div>
              <span>{numbers[num + 1]}</span>
            </Col>
          ))}

        </Row>
      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  projects: state.projects
})

export default connect(mapStateToProps)(withRouter(translate('translations')(DashboardRemainingBox)))



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardRemainingBox.js